import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AppConstants } from '../AppConstants';
import { LoginModalService } from '../login-modal.service';
import { AuthService } from '../service/auth.service';
import { UIRoutes } from '../UIRoutes';
import { first } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { TenantConfigService } from '../service/tenantConfig.service';


declare var gtag: Function;  // Declare the global gtag function


@Component({
  selector: 'app-bottom-container',
  templateUrl: './bottom-container.component.html',
  styleUrls: ['./bottom-container.component.css']
})
export class BottomContainerComponent implements OnInit {

  user;
  showPassword: boolean = false;


  sliderImages: string[] = [
    '../../assets/img/LS2.jpg',
    '../../assets/img/Football.jpg',
    '../../assets/img/PB1.jpg',
    '../../assets/img/G2.jpg',
    '../../assets/img/G1.jpg'
  ];
  currentSliderIndex = 0;

  platformSliderImages: string[] = [
    '../../assets/img/T6.png',
    '../../assets/img/Services2.png',
    '../../assets/img/AP1.png',
    '../../assets/img/Report1.png',

  ];

  tenantServiceIcons: {
    [tenantId: number]: string[];
  } = {};

  currentPlatformSliderIndex = 0;

  animatedUsersCount: number = 0;
  animatedTransactionsCount: number | string = 0;

  rowData: any[] = [];

  tenantImagesObj: {
    [tenantId: string]:
    { image: string; thumbImage: string }[]
  } = {};

  /* @ViewChild('content', {static: false})
  private content: TemplateRef<any>; */

  constructor(
      private modalService: NgbModal,
      private loginModalService: LoginModalService,
      private formBuilder: FormBuilder,
      private authService: AuthService,
      private tenantConfigService: TenantConfigService,
      private router: Router
  ) { }

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }

  ngOnInit() {
    //this.showOnClickVerifyError = false;
    //this.userExistsError = false;
    //this.showSignInError = false;
    if(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT)) {
      this.user = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT))
    } else if(sessionStorage.getItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT)) {
      this.user = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT))
    } else {
      this.user = undefined;
    }

    setInterval(() => {

      this.currentSliderIndex =
        (this.currentSliderIndex + 1) % this.sliderImages.length;

    }, 3000);

    setInterval(() => {

      this.currentPlatformSliderIndex =
        (this.currentPlatformSliderIndex + 1) %
        this.platformSliderImages.length;

    }, 3000);

    this.tenantConfigService.load().subscribe(() => {

        this.getAllTenants();

    });
    this.animatePlatformStats();

    setTimeout(() => {

      const observer = new IntersectionObserver(entries => {

        entries.forEach(entry => {

          if (entry.isIntersecting) {
            entry.target.classList.add('active');
          }

        });

      }, {
        threshold: 0.15
      });

      document.querySelectorAll('.fade-up')
        .forEach(el => observer.observe(el));

    }, 500);

    /* Moved to top bar
    this.loginModalSubscription = this.loginModalService.getLoginModalData().subscribe(data => {
      if(data.showModal) {
        this.displayLoginModalPopup();
      }
    }); */



      /* if (window.screen.width < 568) { // 768px portrait
        this.mobile = true;
      } */
  }

  openRegisterBusinessModal() {
    this.loginModalService.setLoginModalData({
      showModal: true,
      showSignUpForm: true,
      roleIdForSignUp: 2
    });
  }


  getAllTenants(): void {

    this.authService.getAlltenants().subscribe({

      next: (res: any[]) => {

        const all = Array.isArray(res) ? res : [];

        const activeTenants = all.filter(

          tenant =>

            (tenant.status || '').toLowerCase() === 'active'

        );

        //---------------------------------------
        // Sort using TenantConfigService
        //---------------------------------------

        this.rowData =
          this.tenantConfigService.sortTenants(activeTenants);

        //---------------------------------------
        // Images & Service Icons
        //---------------------------------------

        this.rowData.forEach(tenant => {

          this.tenantImagesObj[tenant.id] =
            this.extractTenantImages(tenant);

          this.tenantServiceIcons[tenant.id] =
            this.tenantConfigService.getTenantIcons(tenant.id);

        });

      },

      error: err => {

        console.error('getAllTenants error', err);

      }

    });

  }
  /* getAllTenants(): void {

    this.authService.getAlltenants().subscribe({

      next: (res: any[]) => {

        const all = Array.isArray(res) ? res : [];

         *//* //---------------------------------------------
        // Build Config Lookup Map
        //---------------------------------------------

        const tenantConfigMap = {};

        this.tenantConfig.forEach(config => {

          tenantConfigMap[config.tenantId] = config;

        }); *//*

        //---------------------------------------------
        // Keep Active Tenants Only
        //---------------------------------------------

        const activeTenants = all.filter(

          tenant =>

            (tenant.status || '').toLowerCase() === 'active'

        );

        //---------------------------------------------
        // Store original API order
        //---------------------------------------------

        activeTenants.forEach((tenant, index) => {

          tenant.originalIndex = index;

          const config = this.tenantConfigMap[tenant.id];

          if (config && config.sequence != null) {

            const seq = Number(config.sequence);

            tenant.sequence =
                Number.isFinite(seq)
                    ? seq
                    : Number.MAX_SAFE_INTEGER;

          }
          else {

            tenant.sequence = Number.MAX_SAFE_INTEGER;

          }

        });

        //---------------------------------------------
        // City Priority
        //---------------------------------------------

        const cityOrder = {

          pune: 1,

          nashik: 2,

          bangalore: 3

        };

        //---------------------------------------------
        // Sort
        //---------------------------------------------

        activeTenants.sort((a, b) => {

          const cityA =
            (a.address?.city || '').trim().toLowerCase();

          const cityB =
            (b.address?.city || '').trim().toLowerCase();

          const cityPriorityA =
              this.cityDisplayOrder[cityA] ?? 999;

          const cityPriorityB =
              this.cityDisplayOrder[cityB] ?? 999;

          //---------------------------------------
          // City Order
          //---------------------------------------

          if (cityPriorityA !== cityPriorityB) {

            return cityPriorityA - cityPriorityB;

          }

          //---------------------------------------
          // Remaining cities alphabetical
          //---------------------------------------

          if (cityPriorityA === 999) {

            const cityCompare =
              cityA.localeCompare(cityB);

            if (cityCompare !== 0) {

              return cityCompare;

            }

          }

          //---------------------------------------
          // Sequence inside city
          //---------------------------------------

          if (a.sequence !== b.sequence) {

            return a.sequence - b.sequence;

          }

          //---------------------------------------
          // Duplicate sequence OR missing sequence
          // Preserve API order
          //---------------------------------------

          return a.originalIndex - b.originalIndex;

        });

        //---------------------------------------------
        // Assign
        //---------------------------------------------

        this.rowData = activeTenants;

        //---------------------------------------------
        // Images & Service Icons
        //---------------------------------------------

        this.rowData.forEach(tenant => {

          this.tenantImagesObj[tenant.id] =
            this.extractTenantImages(tenant);

           const config = this.tenantConfigMap[tenant.id];

           this.tenantServiceIcons[tenant.id] =
               this.getServiceIcons(config?.services || []);
           *//* this.authService
            .getTenantServiceIcons(tenant.id)
            .subscribe(icons => {

              this.tenantServiceIcons[tenant.id] = icons;

            }); *//*

        });

      },

      error: err => {

        console.error("getAllTenants error", err);

      }

    });

  } */


  /* getAllTenants(): void {

    this.authService.getAlltenants().subscribe({

      next: (res: any[]) => {

        const all = Array.isArray(res) ? res : [];

        this.rowData = all
          .filter(
            t => (t.status || '').toLowerCase() === 'active'
          )
          .sort((a, b) => {

            const cityA =
              (a.address?.city || '').toLowerCase();

            const cityB =
              (b.address?.city || '').toLowerCase();

            // Pune first
            if (cityA === 'pune' && cityB !== 'pune') {
              return -1;
            }

            if (cityA !== 'pune' && cityB === 'pune') {
              return 1;
            }

            // then alphabetical
            return cityA.localeCompare(cityB);
          });

        this.rowData.forEach(tenant => {

          this.tenantImagesObj[tenant.id] =
            this.extractTenantImages(tenant);

           this.authService
             .getTenantServiceIcons(tenant.id)
             .subscribe(icons => {

               this.tenantServiceIcons[tenant.id] = icons;

             });
        });



      },

      error: (err) => {

        console.error('getAllTenants error:', err);
      }
    });
  } */

  animatePlatformStats(): void {

    const usersTarget = 12;

    const transactionsTarget = 200000;

    let usersCurrent = 0;

    let transactionsCurrent = 0;

    const usersInterval = setInterval(() => {

      usersCurrent += 1;

      this.animatedUsersCount = usersCurrent;

      if (usersCurrent >= usersTarget) {

        clearInterval(usersInterval);
      }

    }, 120);

    const transactionsInterval = setInterval(() => {

      transactionsCurrent += 5000;

      this.animatedTransactionsCount =
        transactionsCurrent.toLocaleString('en-IN');

      if (transactionsCurrent >= transactionsTarget) {

        this.animatedTransactionsCount = '2 Lakh+';

        clearInterval(transactionsInterval);
      }

    }, 60);
  }

  extractTenantImages(tenant: any):
    { image: string; thumbImage: string }[] {

      const images:
        { image: string; thumbImage: string }[] = [];

      if (tenant.tenantImage?.totalImageCount) {

        const tempImages: string[] = [];

        for (
          let i = 1;
          i <= tenant.tenantImage.totalImageCount;
          i++
        ) {

          const key = `image${i}`;

          if (tenant.tenantImage[key]) {
            tempImages.push(tenant.tenantImage[key]);
          }
        }

        const defaultIndex =
          tenant.tenantImage.defaultImageIndex ?? 0;

        const sortedImages = [
          tempImages[defaultIndex],
          ...tempImages.filter((_, idx) => idx !== defaultIndex)
        ];

        sortedImages.forEach(img => {
          images.push({
            image: img,
            thumbImage: img
          });
        });
      }
      if (images.length === 0) {

        images.push({

          image: "../assets/img/noImage.png",

          thumbImage: "../assets/img/noImage.png"
        });
      }

      return images;
    }

  productDetails(id: string | number): void {

    this.router.navigate(['/product-list', id]);
  }




  navigateToBusinesses() {
      // Navigate to your desired HTML page
      this.router.navigate(['/businesses']); // Change '/your-page' to the actual route of your HTML page
  }



  isUserDefined() {
    return this.authService.isLoggedIn();
  }


  businessTypes = [
    { name: 'Sports', icon: '../../assets/img/badminton.svg' },
    { name: 'Hospitals & Clinics', icon: '../../assets/img/clinic.svg' },
    { name: 'Salon', icon: '../../assets/img/hairdresser.svg' },
    /* { name: 'Workspaces', icon: '../../assets/img/workspace.svg' }, */
    { name: 'Meeting Rooms', icon: '../../assets/img/meeting.svg' },
    { name: 'Trainers', icon: '../../assets/img/trainer-male.svg' },
    { name: 'Banquet Halls', icon: '../../assets/img/wedding-arch.svg' }
  ];

  businessFeatures = [
    {
      title: 'Configurable Services',
      icon: '../../assets/img/setting.svg',
      details: [
        'Single or Multi-Session',
        'Configurable Duration',
        'Configure price for each slot/session',
        'Capacity per session',
      ]
    },
    {
      title: 'Notifications',
      icon: '../../assets/img/email-notification.svg',
      details: ['Customer and Admin Notifications', 'Online Receipts', 'Reminders']
    },
    {
      title: 'Reports',
      icon: '../../assets/img/report.svg',
      details: ['Analytics Dashboard, Reports for a Time Period', 'Transaction Report', 'Service and Venue Level Reports']
    },
    {
      title: 'Payments',
      icon: '../../assets/img/secure-payment.svg',
      details: ['Online Payments', 'Transparent Pricing']
    },
    /* {
      title: 'Policy Rules',
      icon: '../../assets/img/policy-rules.svg',
      details: ['Custom Define Policy Rules for the Customers']
    } */
  ];

}
